import {cs} from "../../../../../react/chain-services";
import {UseState} from "../../../../../react/use-state";
import {chain} from "../../../../../utils/fs";
import {reverse, sort} from "../../../../../utils/collections";
import {Types} from "../../../../../types";

export const Sorting = <Row>({next, getDefault=undefined}:{
    next       : (v:Types.Common.UiComponents.Heavy.Common.Design2.DataTable.Sorting.Next<Row>) => JSX.Element,
    getDefault : () => {columnIndex: number, direction: "asc" | "desc"}
}) => cs(
    ["state", (_, next) => UseState({getInitValue: getDefault, next})],
    ({state}) => next({
        isSortingActiveForColumn: ({columnIndex}) => state.value?.columnIndex === columnIndex,
        toggleColumn: ({columnIndex, defaultDirection=undefined}) => state.change((s) => (s == null || s.columnIndex !== columnIndex) ? {
            columnIndex: columnIndex,
            direction: defaultDirection ?? "asc",
        } : s.direction === (defaultDirection ?? "asc") ? {
            columnIndex: columnIndex,
            direction: (defaultDirection ?? "asc") === "asc" ? "desc" : "asc",
        } : {
            columnIndex: columnIndex,
            direction: (defaultDirection ?? "asc"),
        }),
        direction: state.value?.direction,
        apply: (rows, getSortValue) => !state.value ? rows : chain(
            rows,
            (_) => sort(_, (row:Row) => getSortValue(row, state.value.columnIndex)),
            (_) => state.value.direction === "asc" ? _ : reverse(_),
        ),
        value: state.value,
    }),
);
